import { config } from '@brands/config/config';
import { usePostAuth } from '@brands/hooks/usePostAuth';
import { passwordlessVerify } from '@brands/services/auth/passwordlessVerify';
import React, { FC, useEffect, useRef, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';

const PasswordlessLinkVerify: FC = () => {
  const { triggerPostAuth } = usePostAuth();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState<string | null>(null);
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return; // guard StrictMode double-invoke
    ran.current = true;

    const token = searchParams.get('token');
    if (!token) {
      setError('This sign-in link is missing its token.');
      return;
    }

    (async () => {
      try {
        const response = await passwordlessVerify({
          token,
          organization_id: config.organization_id,
        });
        await triggerPostAuth(response, { event: 'login' });
      } catch {
        setError('This sign-in link has expired or already been used.');
      }
    })();
  }, [searchParams, triggerPostAuth]);

  if (error) {
    return (
      <div style={{ maxWidth: 420, margin: '80px auto', textAlign: 'center' }}>
        <h1>Sign-in link problem</h1>
        <p>{error}</p>
        <Link to="/sign-in/code">Request a new link</Link>
      </div>
    );
  }

  return (
    <div style={{ maxWidth: 420, margin: '80px auto', textAlign: 'center' }}>
      <h1>Signing you in…</h1>
      <p>One moment while we verify your link.</p>
    </div>
  );
};

export default PasswordlessLinkVerify;
